function s() {
  let t = null;
  const o = (n) => {
    const e = n.target.innerWidth;
    t && typeof t == "function" && t(e);
  };
  return { mounted: (n, e) => {
    typeof window > "u" || (t = e == null ? void 0 : e.value, window.addEventListener("resize", o));
  }, unmounted: (n) => {
    window.removeEventListener("resize", o);
  } };
}
export {
  s as resizeAwds
};
